import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  Divider,
  CardContent,
  Grid,
  TextField,
  Button,
  CardActions,
  Switch,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Chip
} from '@material-ui/core';
import {
  KeyboardDatePicker
} from '@material-ui/pickers';
import moment from 'moment';
import clsx from 'clsx';
import ErrorModal from 'src/components/ErrorModal';
import UploadPicker from '../UploadPicker';
import { Autocomplete } from '@material-ui/lab';
import { SingleAppDateTimePicker } from '../DatePicker/AppDateTimePicker';
import ModalDialog from '../ModalDialog';
import Modal from '../Modal';
import { formatDateString } from 'src/utils/getTimeFromString';
import OverrideModal from '../OverrideModal';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%',
    borderRadius: '10px'
  },
  actions: {
    justifyContent: 'space-between'
  }
}));

// EXAMPLE FIELDS

// const test_fields = [
//   {
//     variant: 'text',
//     label: 'Comp name',
//     name: 'text_field'
//   },
// ];

function capitalizeFirstLetter(x) {
  return x.charAt(0).toUpperCase() + x.slice(1);
}

const chips = ["monday", "tuesday", "wednesday", "thursday", "friday"];

function CompetencySaveModal({
  open,
  onClose,
  onSave,
  onChange,
  className,
  cardTitle,
  fields,
  formState,
  setFormState,
  error,
  ...rest
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [isOpenOverrideModal, setIsOpenOverrideModal] = useState(false);
  const [isRange, setIsRange] = useState(true);

  function fieldToComponent(field) {
    switch (field.type) {
      case 'password':
      case 'number':
      case 'email':
      case 'text':
        return (
          <TextField
            label={field.label}
            fullWidth
            onChange={evt => {
              var news = { ...formState };
              news[field.name] = evt.target.value;
              setFormState(news);
            }}
            placeholder={field.placeholder || ''}
            type={field.type}
            value={formState[field.name] || ''}
            variant="outlined"
            multiline={field.multiline || false}
            rows={field.rows}
            rowsMax={field.rowsMax}
            inputProps={{
              maxlength: field.maxLength
            }}
            escapeHtml="false"
          />
        );
      case 'switch':
        return (
          <>
            <Typography variant="h6">{field.label}</Typography>
            <Typography variant="body2">{field.description}</Typography>
            <Switch
              color="primary"
              checked={formState[field.name] || false}
              onChange={evt => {
                var news = { ...formState };
                news[field.name] = evt.target.checked;
                setFormState(news);
              }}
            />
          </>
        );
      case 'file':
        return (
          <Grid container spacing={2}>
            <Grid item>
              <Typography variant="h6">{field.label}</Typography>
              <Typography variant="body2">{field.description}</Typography>
            </Grid>
            <Grid item>
              <UploadPicker
                title={field.label}
                acceptType={field.acceptType || undefined}
                onSelected={uploadItem => {
                  var news = { ...formState };
                  news[field.name] = uploadItem;
                  setFormState(news);
                }}
              />
            </Grid>
          </Grid>
        );
      case 'date':
        return (
          <KeyboardDatePicker
            onChange={date => {
              var news = { ...formState };
              news[field.name] = date;
              setFormState(news);
            }}
            value={formState[field.name] ? moment(formState[field.name]) : null}
            inputVariant="outlined"
            format="DD/MM/YYYY"
            fullWidth
            label={field.label}
            placeholder={'DD/MM/YYYY'}
            autoOk={true}
          />
        );
      case 'datetime':
        /*return (
          <KeyboardDateTimePicker
            onChange={date => {
              console.log(date)
              var news = { ...formState };
              news[field.name] = date;
              setFormState(news);
            }}
            value={formState[field.name] ? moment(formState[field.name]) : null}
            inputVariant="outlined"
            format="DD/MM/YYYY hh:mm a"
            minutesStep={15}
            fullWidth
            label={field.label}
            placeholder={'DD/MM/YYYY hh:mm'}
          />
        );*/
        return <SingleAppDateTimePicker
          onChange={date => { 
            var news = { ...formState };
            news[field.name] = date;
            setFormState(news);
          }}

          value={formState[field.name] ? moment(formState[field.name]) : null}
          format="DD/MM/YYYY hh:mm a"  
          label={field.label} 
        />
      case 'range-date':
        return <CustomRangeDatePicker />
      case 'dropdown':
        // {
        //   type: 'dropdown',
        //   label: 'Comp name',
        //   name: 'dropdown_field',
        //   options: [
        //     {
        //       value: 'cake',
        //       text: 'Cake'
        //     }
        //   ]
        // };
        return (
          <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ width: '100%' }}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              {field.label}
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              onChange={selected => {
                var news = { ...formState };
                news[field.name] = selected.target.value;
                setFormState(news);
              }}
              value={formState[field.name] || false}
              name={field.name}
              label={field.label}
            >
              {field.options.map(option => (
                <MenuItem value={option.value}>{option.text}</MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      default:
        throw new Error('Unable to find matching component');
    }
  }

  const [options, setOptions] = React.useState(chips);
  const [input, setInput] = React.useState('');

  React.useEffect(() => {
    setOptions(
      chips.filter(x => x.toLowerCase().includes(input.toLowerCase()))
    );
  }, [input]);

  const handleCloseOverrideModal = () => {
    setIsOpenOverrideModal(false);
  };

  const CustomRangeDatePicker = () => {
    return (
      <div className="react-google-flight-datepicker">
        <div className="date-picker">
          <div className="date-picker-input-wrap">
            <div className="date-picker-input" onClick={()=> {setIsOpenOverrideModal(true); setIsRange(true)}}>
              <div className="date-picker-date-group">
                <div className="date is-focus" role="button" tabIndex="0" id="start-date-input-button">
                  <div className="selected-date">{formState?.startDate ? formatDateString(formState?.startDate) : formatDateString(new Date())}</div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-calendar">
                    <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"></path>
                    </svg>
                    <label></label>
                </div>
              </div>
              <label className="force">Start Date</label>
            </div>
            <div className="date-picker-input" onClick={()=> setIsOpenOverrideModal(true)}>
              <div className="date-picker-date-group">
                <div className="date" role="button" tabIndex="0" id="end-date-input-button">
                  <div className="selected-date">{formState.endDate ? formatDateString(formState?.endDate) : formatDateString(new Date())}</div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-calendar">
                    <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"></path>
                    </svg>
                    <label></label>
                </div>
              </div>
              <label className="">End Date</label>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
    <Modal onClose={onClose} isShow={open}>
      <ModalDialog style={{
          width: '700px',
          display: 'contents',
          maxHeight: '90vh',
          overflowY: 'auto',
          overflowX: 'hidden',
      }}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <ErrorModal error={error} />
        <form>
          <CardHeader title={cardTitle} />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              {fields.map(field => (
                <Grid item md={field.mdSize || 6} xs={12}>
                  {fieldToComponent(field)}
                </Grid>
              ))}
              {formState.partTimeDays && !formState.fullTime && (
                <Grid item md={6} xs={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ width: '100%' }}
                  >
                    {/* <InputLabel id="demo-simple-select-outlined-label">
                      Part Time Days
                    </InputLabel> */}
                    <Autocomplete
                      multiple
                      options={options}
                      value={formState.partTimeDays}
                      getOptionLabel={option => capitalizeFirstLetter(option)}
                      onChange={(_, newValue) => setFormState({...formState, partTimeDays: newValue})}
                      renderTags={(value, getTagProps) => 
                        value.map((option, index) => (
                          <Chip
                            label={capitalizeFirstLetter(option)}
                            color={'default'}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderInput={params => (
                        <TextField
                          {...params}
                          label="Weekdays"
                          variant="outlined"
                          onChange={inp => setInput(inp.target.value)}
                          escapeHtml="false"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <Grid container spacing={3}>
              <Grid item>
                <Button onClick={onClose}>Close</Button>
              </Grid>
              <Grid item>
                <Button
                  default="primary"
                  onClick={async () => {
                    setLoading(true);
                    try {
                      await onSave();
                    } catch (err) {
                      console.log('Unable to save', err);
                    }
                    setLoading(false);
                  }}
                  variant="contained"
                >
                  {loading ? <CircularProgress size={20} /> : 'Save'}
                </Button>
              </Grid>
            </Grid>
          </CardActions>
        </form>
      </Card>
      </ModalDialog>
    </Modal>
    <OverrideModal
      isOpen={isOpenOverrideModal}
      onClose={handleCloseOverrideModal}   
      isRange={isRange} 
      onChange={date => {
        setFormState({ ...formState, startDate: date.start, endDate: date.end })
      }}
      data={
        {
          start: formState.startDate ? formState.startDate : new Date(),
          end: formState.endDate ? formState.endDate : new Date()
        }
      }
    />
    </>
   
  );
}

export default CompetencySaveModal;
